import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface Alert { timestamp: string; severity: string; message: string; service?: string; }

export function useAlerts(hours = 24) {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<{ alerts?: Alert[] }>(`/api/dashboard/alerts?hours=${hours}`, token)
      .then((d) => { if (!cancelled) { setAlerts(d.alerts || []); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, hours, refreshKey, logout]);

  return { alerts, loading };
}
